export default __webpack_public_path__ + "870a54f7431f57371fd71979a17c5aa0.svg";